import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "d-flex align-center" };
const _hoisted_2 = { class: "d-flex align-center" };
const _hoisted_3 = { class: "d-flex align-center" };
import { ref, computed, watch, onMounted } from 'vue';
import InputRow from '@/components/Form/InputRow.vue';
import DeliveryFeeGroup from '@/views/Dialog/DeliveryFeeGroup/index.vue';
import WorkerCashAutoDeductGroup from '@/views/Dialog/CashAutoDeductGroup/index.vue';
import AllocatedCancelPenaltyGroup from '@/views/Dialog/AllocatedCancelPenaltyGroup/index.vue';
import { acceptedOrderViewLimitCountItems, cardDeviceTypeCode, orderDelayTimeSecondItems, validationLimitingValue, } from '@/constants';
import { formattedToInteger, formattedToNumber, numberToFormatted, } from '@/utils';
import { objDeepCopy } from '@/utils/object';
import { i18n } from '@/locales';
const lc = 'views.worker_management.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliverySetting',
    props: {
        workerDetail: { default: () => ({}) },
        formRules: { default: () => ({}) },
        headCol: { default: 3 }
    },
    emits: ["setFormData", "setOriginData"],
    setup(__props, { emit: __emit }) {
        // PAGE: 라이더 상세정보 > 배달설정 수정
        const { t } = i18n;
        const props = __props;
        // Emits
        const emit = __emit;
        // Constants
        const { BAROMONEY_MAX_LENGTH, MAX_ALLOCATE_COUNT_LENGTH, MIN_FINISH_MINUTE_AFTER_ALLOCATED_LENGTH, } = validationLimitingValue;
        // Reactive data
        const cardDeviceTypeOptions = Object.values(cardDeviceTypeCode);
        const orderDelayTimeSecondOptions = Object.values(orderDelayTimeSecondItems);
        const acceptedOrderViewLimitCountOptions = Object.values(acceptedOrderViewLimitCountItems);
        const requiredOptions = [
            {
                label: t(`${lc}required`),
                value: true,
            },
            {
                label: t(`${lc}selection`),
                value: false,
            },
        ];
        const exposureOptions = [
            {
                label: t(`${lc}exposure`),
                value: true,
            },
            {
                label: t(`${lc}hidden`),
                value: false,
            },
        ];
        const availabilityOptions = [
            {
                label: t(`${lc}available`),
                value: true,
            },
            {
                label: t(`${lc}disable`),
                value: false,
            },
        ];
        const authorityOptions = [
            {
                label: t(`${lc}available`),
                value: 'GRANTED',
            },
            {
                label: t(`${lc}disable`),
                value: 'NONE',
            },
        ];
        // Form data
        const formData = {
            // 단말기 유형
            cardDeviceType: props.workerDetail.cardDeviceType,
            // 락타임
            orderDelayTimeSecond: props.workerDetail.orderDelayTimeSecond,
            // 접수 목록 제한
            acceptedOrderViewLimitCount: props.workerDetail.acceptedOrderViewLimitCount,
            // 배차 제한잔액
            allocateLimitBaromoney: props.workerDetail.allocateLimitBaromoney,
            // 최대 배차 가능 건수
            maxAllocateCount: props.workerDetail.maxAllocateCount,
            // 배차 후 완료가능 최소 시간
            minFinishMinuteAfterAllocated: props.workerDetail.minFinishMinuteAfterAllocated,
            // GPS 활성화
            isForceGpsOn: props.workerDetail.isForceGpsOn,
            // 공유배달 버튼
            isSharedOrderHidden: props.workerDetail.isSharedOrderHidden,
            // 배차취소 권한
            isPossibleToCancelAllocatedOrder: props.workerDetail.isPossibleToCancelAllocatedOrder,
            // 픽업예상시간 수정 권한
            isImpossibleToChangePickupExpectedAt: props.workerDetail.isImpossibleToChangePickupExpectedAt,
            // 도착지 주소 수정 권한
            isPossibleToChangeDropAddress: props.workerDetail.isPossibleToChangeDropAddress,
            // 결제수단 변경 권한
            changePaymentAuthorityType: props.workerDetail.changePaymentAuthorityType,
            // 관제 권한
            isPossibleToControl: props.workerDetail.isPossibleToControl,
            // 상점 송금 권한
            isPossibleToSendHubBaromoney: props.workerDetail.isPossibleToSendHubBaromoney,
            // 라이더 수수료 그룹
            workerDeliveryFeeGroupId: props.workerDetail.workerDeliveryFeeGroupId,
            // 자동 차감 그룹
            workerCashAutoDeductGroupId: props.workerDetail.workerCashAutoDeductGroupId,
            // 배차취소 패널티 그룹
            workerPenaltyGroupId: props.workerDetail.workerPenaltyGroupId,
        };
        // formData에 groupName이 들어가면 error 도출에 따른 분리
        const { workerDeliveryFeeGroupName: initialWorkerDeliveryFeeGroupName, workerCashAutoDeductGroupName: initialWorkerCashAutoDeductGroupName, workerPenaltyGroupName: initialWorkerPenaltyGroupName, } = props.workerDetail;
        const updateFormData = ref(objDeepCopy(formData));
        const workerDeliveryFeeGroupName = ref(initialWorkerDeliveryFeeGroupName);
        const workerCashAutoDeductGroupName = ref(initialWorkerCashAutoDeductGroupName);
        const workerPenaltyGroupName = ref(initialWorkerPenaltyGroupName);
        const allocateLimitBaromoneyMaxLength = ref(8);
        // Computed properties
        const cardDeviceType = computed({
            get: () => updateFormData.value.cardDeviceType,
            set: (value) => {
                updateFormData.value.cardDeviceType = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const orderDelayTimeSecond = computed({
            get: () => updateFormData.value.orderDelayTimeSecond,
            set: (value) => {
                updateFormData.value.orderDelayTimeSecond = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const acceptedOrderViewLimitCount = computed({
            get: () => updateFormData.value.acceptedOrderViewLimitCount,
            set: (value) => {
                updateFormData.value.acceptedOrderViewLimitCount = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const formattedAllocateLimitBaromoneyComputed = computed({
            get: () => {
                if (updateFormData.value.allocateLimitBaromoney === null) {
                    return '';
                }
                return numberToFormatted(updateFormData.value.allocateLimitBaromoney);
            },
            set: (value) => {
                if (value === '') {
                    updateFormData.value.allocateLimitBaromoney = null;
                    emit('setFormData', updateFormData.value);
                    return;
                }
                updateFormData.value.allocateLimitBaromoney = formattedToInteger(value);
                emit('setFormData', updateFormData.value);
            },
        });
        const formattedMaxAllocateCountComputed = computed({
            get: () => {
                if (updateFormData.value.maxAllocateCount === null) {
                    return '';
                }
                return numberToFormatted(updateFormData.value.maxAllocateCount);
            },
            set: (value) => {
                if (value === '') {
                    updateFormData.value.maxAllocateCount = null;
                    emit('setFormData', updateFormData.value);
                    return;
                }
                updateFormData.value.maxAllocateCount = formattedToNumber(value);
                emit('setFormData', updateFormData.value);
            },
        });
        const formattedMinFinishMinuteAfterAllocatedComputed = computed({
            get: () => {
                if (updateFormData.value.minFinishMinuteAfterAllocated === null) {
                    return '';
                }
                return numberToFormatted(updateFormData.value.minFinishMinuteAfterAllocated);
            },
            set: (value) => {
                if (value === '') {
                    updateFormData.value.minFinishMinuteAfterAllocated = null;
                    emit('setFormData', updateFormData.value);
                    return;
                }
                updateFormData.value.minFinishMinuteAfterAllocated = formattedToNumber(value);
                emit('setFormData', updateFormData.value);
            },
        });
        const isForceGpsOn = computed({
            get: () => updateFormData.value.isForceGpsOn,
            set: (value) => {
                updateFormData.value.isForceGpsOn = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const isSharedOrderHidden = computed({
            get: () => updateFormData.value.isSharedOrderHidden,
            set: (value) => {
                updateFormData.value.isSharedOrderHidden = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const isPossibleToCancelAllocatedOrder = computed({
            get: () => updateFormData.value.isPossibleToCancelAllocatedOrder,
            set: (value) => {
                updateFormData.value.isPossibleToCancelAllocatedOrder = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const isImpossibleToChangePickupExpectedAt = computed({
            get: () => updateFormData.value.isImpossibleToChangePickupExpectedAt,
            set: (value) => {
                updateFormData.value.isImpossibleToChangePickupExpectedAt = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const isPossibleToChangeDropAddress = computed({
            get: () => updateFormData.value.isPossibleToChangeDropAddress,
            set: (value) => {
                updateFormData.value.isPossibleToChangeDropAddress = value;
                emit('setFormData', updateFormData.value);
            },
        });
        const changePaymentAuthorityType = computed({
            get: () => {
                /**
                 * 불가: NONE , 가능: PRE_PAYMENT_GRANTED, GRANTED
                 * PRE_PAYMENT_GRANTED는 점진적 제거로 수정 시 GRANTED로 수정됨
                 */
                if (updateFormData.value.changePaymentAuthorityType !== 'NONE') {
                    return 'GRANTED';
                }
                return updateFormData.value.changePaymentAuthorityType;
            },
            set: (value) => {
                updateFormData.value.changePaymentAuthorityType = value;
                emit('setFormData', updateFormData.value);
            },
        });
        // 관제 권한
        const isPossibleToControl = computed({
            get: () => updateFormData.value.isPossibleToControl,
            set: (value) => {
                updateFormData.value.isPossibleToControl = value;
                emit('setFormData', updateFormData.value);
            },
        });
        // 상점 송금 권한
        const isPossibleToSendHubBaromoney = computed({
            get: () => updateFormData.value.isPossibleToSendHubBaromoney,
            set: (value) => {
                updateFormData.value.isPossibleToSendHubBaromoney = value;
                emit('setFormData', updateFormData.value);
            },
        });
        // Methods
        const onBlurOrderDelayTimeSecondField = (value) => {
            if (!value && value !== 0) {
                updateFormData.value.orderDelayTimeSecond = props.workerDetail.orderDelayTimeSecond;
                emit('setFormData', updateFormData.value);
            }
        };
        const onBlurAcceptedOrderViewLimitCountField = (value) => {
            if (!value && value !== 0) {
                updateFormData.value.acceptedOrderViewLimitCount = props.workerDetail.acceptedOrderViewLimitCount;
                emit('setFormData', updateFormData.value);
            }
        };
        const onBlurAllocateLimitBaromoneyField = (value) => {
            if (!value) {
                updateFormData.value.allocateLimitBaromoney = 0;
                emit('setFormData', updateFormData.value);
            }
        };
        const onBlurMaxAllocateCountField = (value) => {
            if (!value) {
                updateFormData.value.maxAllocateCount = 3;
                emit('setFormData', updateFormData.value);
            }
        };
        const onBlurMinFinishMinuteAfterAllocatedField = (value) => {
            if (!value) {
                updateFormData.value.minFinishMinuteAfterAllocated = 10;
                emit('setFormData', updateFormData.value);
            }
        };
        const selectWorkerDeliveryFeeGroup = ({ groupId, groupName }) => {
            if (!groupId) {
                return;
            }
            updateFormData.value.workerDeliveryFeeGroupId = groupId;
            workerDeliveryFeeGroupName.value = groupName;
            emit('setFormData', updateFormData.value);
        };
        const selectWorkerCashAutoDeductGroup = ({ groupId, groupName }) => {
            if (!groupId) {
                return;
            }
            updateFormData.value.workerCashAutoDeductGroupId = groupId;
            workerCashAutoDeductGroupName.value = groupName;
            emit('setFormData', updateFormData.value);
        };
        const selectAllocatedCancelPenaltyGroup = ({ groupId, groupName }) => {
            if (!groupId) {
                return;
            }
            updateFormData.value.workerPenaltyGroupId = groupId;
            workerPenaltyGroupName.value = groupName;
            emit('setFormData', updateFormData.value);
        };
        // Watchers
        watch(() => updateFormData.value.allocateLimitBaromoney, (value) => {
            allocateLimitBaromoneyMaxLength.value = BAROMONEY_MAX_LENGTH;
            if (value < 0) {
                allocateLimitBaromoneyMaxLength.value += 1;
            }
        });
        // Lifecycle
        onMounted(() => {
            emit('setOriginData', formData);
            emit('setFormData', updateFormData.value);
        });
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            return (_openBlock(), _createElementBlock("div", null, [
                _createCommentVNode(" 카드 단말기 유형 "),
                _createVNode(InputRow, {
                    "data-cy": "worker-card-device-type-input-row",
                    label: _ctx.$t(`${lc}card_device`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                            "item-title": "text",
                            "item-value": "value",
                            modelValue: cardDeviceType.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((cardDeviceType).value = $event)),
                            items: _unref(cardDeviceTypeOptions),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto"
                        }, null, 8 /* PROPS */, ["modelValue", "items"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 락타임 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}order_delay_time_second`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                            "item-title": "text",
                            "item-value": "value",
                            modelValue: orderDelayTimeSecond.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((orderDelayTimeSecond).value = $event)),
                            items: _unref(orderDelayTimeSecondOptions),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            onBlur: _cache[2] || (_cache[2] = ($event) => (onBlurOrderDelayTimeSecondField(orderDelayTimeSecond.value)))
                        }, null, 8 /* PROPS */, ["modelValue", "items"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 접수 목록 제한 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}accepted_order_view_limit_count`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                            "item-title": "text",
                            "item-value": "value",
                            modelValue: acceptedOrderViewLimitCount.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((acceptedOrderViewLimitCount).value = $event)),
                            items: _unref(acceptedOrderViewLimitCountOptions),
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "auto",
                            onBlur: _cache[4] || (_cache[4] = ($event) => (onBlurAcceptedOrderViewLimitCountField(acceptedOrderViewLimitCount.value)))
                        }, null, 8 /* PROPS */, ["modelValue", "items"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 배차 제한잔액 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}allocate_limit_baromoney`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: formattedAllocateLimitBaromoneyComputed.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formattedAllocateLimitBaromoneyComputed).value = $event)),
                            density: "compact",
                            variant: "outlined",
                            inputmode: "numeric",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.currency'),
                            maxlength: allocateLimitBaromoneyMaxLength.value,
                            "validate-on": "blur",
                            oninput: "javascript: this.value = this.value.replace(/[^-?0-9]|[-]{2,}|-0|\\d{1}-\\d{1}/g, '' );",
                            onBlur: _cache[6] || (_cache[6] = ($event) => (onBlurAllocateLimitBaromoneyField(formattedAllocateLimitBaromoneyComputed.value)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 최대 배차 가능 건수 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}max_allocate_count`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            class: "cy-max-allocate-count",
                            modelValue: formattedMaxAllocateCountComputed.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((formattedMaxAllocateCountComputed).value = $event)),
                            density: "compact",
                            variant: "outlined",
                            inputmode: "numeric",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.count'),
                            maxlength: _unref(MAX_ALLOCATE_COUNT_LENGTH),
                            "validate-on": "blur",
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            onBlur: _cache[8] || (_cache[8] = ($event) => (onBlurMaxAllocateCountField(formattedMaxAllocateCountComputed.value)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 배차 후 완료가능 최소시간 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}min_finish_minute_after_allocated`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            class: "cy-finish",
                            modelValue: formattedMinFinishMinuteAfterAllocatedComputed.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((formattedMinFinishMinuteAfterAllocatedComputed).value = $event)),
                            density: "compact",
                            variant: "outlined",
                            inputmode: "numeric",
                            "hide-details": "auto",
                            suffix: _ctx.$t('common.minutes'),
                            "validate-on": "blur",
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            rules: _ctx.formRules.minFinishMinuteAfterAllocated,
                            maxlength: _unref(MIN_FINISH_MINUTE_AFTER_ALLOCATED_LENGTH),
                            onBlur: _cache[10] || (_cache[10] = ($event) => (onBlurMinFinishMinuteAfterAllocatedField(formattedMinFinishMinuteAfterAllocatedComputed.value)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "rules", "maxlength"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" GPS 활성화 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}is_gps_on`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isForceGpsOn.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((isForceGpsOn).value = $event)),
                            name: "radio",
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(requiredOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 공유배달 버튼 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}is_share_order_hidden`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isSharedOrderHidden.value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((isSharedOrderHidden).value = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(exposureOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 배차취소 권한 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}right_to_cancel_allocate`),
                    "head-col": props.headCol,
                    "is-required": "",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isPossibleToCancelAllocatedOrder.value,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((isPossibleToCancelAllocatedOrder).value = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availabilityOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 픽업예상시간 수정 권한 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}right_to_calcel_allocated_order`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isImpossibleToChangePickupExpectedAt.value,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((isImpossibleToChangePickupExpectedAt).value = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availabilityOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 도착지 주소 수정 권한 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}right_to_change_drop_address`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isPossibleToChangeDropAddress.value,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((isPossibleToChangeDropAddress).value = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availabilityOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 결제수단 변경 권한 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}right_to_change_payment_authority_type`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: changePaymentAuthorityType.value,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((changePaymentAuthorityType).value = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(authorityOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 관제 권한 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}right_to_control_change`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isPossibleToControl.value,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((isPossibleToControl).value = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availabilityOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 상점 송금 권한 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}right_to_store_remittance`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: isPossibleToSendHubBaromoney.value,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((isPossibleToSendHubBaromoney).value = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availabilityOptions, (option, key) => {
                                    return _createVNode(_component_v_radio, {
                                        key: key,
                                        label: option.label,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]);
                                }), 64 /* STABLE_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 라이더 수수료 그룹 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}worker_delivery_fee_group`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_v_text_field, {
                                value: workerDeliveryFeeGroupName.value,
                                filled: "",
                                disabled: "",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                class: "grow"
                            }, null, 8 /* PROPS */, ["value"]),
                            _createVNode(DeliveryFeeGroup, { onOnApply: selectWorkerDeliveryFeeGroup })
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 자동 차감 그룹 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}cash_auto_deduct_group`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_text_field, {
                                modelValue: workerCashAutoDeductGroupName.value,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((workerCashAutoDeductGroupName).value = $event)),
                                filled: "",
                                disabled: "",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                class: "grow"
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(WorkerCashAutoDeductGroup, { onOnApply: selectWorkerCashAutoDeductGroup })
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"]),
                _createCommentVNode(" 배차취소 패널티 그룹 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${lc}allocated_cancel_penalty_group`),
                    "head-col": props.headCol,
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_text_field, {
                                modelValue: workerPenaltyGroupName.value,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((workerPenaltyGroupName).value = $event)),
                                filled: "",
                                disabled: "",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                class: "grow"
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(AllocatedCancelPenaltyGroup, { onOnApply: selectAllocatedCancelPenaltyGroup })
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "head-col"])
            ]));
        };
    }
});
